var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RouterLink as Link } from '../Router/';

import { Module, ModuleLink, ModuleGrid, ModuleProgress, ModuleMedia, ModuleContent, ModuleHeader, ModuleBody, ModuleFooter, ModuleTitle, ModuleDescription, ModuleLabel, ModuleMetadata, ModuleStatus, ModuleDate, ModuleByline, ModuleAction } from '../';

import "./FinderModule.scss";

var FinderModule = (_temp2 = _class = function (_Component) {
    _inherits(FinderModule, _Component);

    function FinderModule() {
        var _temp, _this, _ret;

        _classCallCheck(this, FinderModule);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getLabel = function () {
            var _this$props = _this.props,
                label = _this$props.label,
                documentType = _this$props.documentType,
                mediaType = _this$props.mediaType;


            if (label) {
                return label;
            }

            label = "";

            if (documentType) {
                label = "document/" + documentType;
            } else if (mediaType) {
                label = "media/" + mediaType;
            } else {
                label = "unknown";
            }

            return label;
        }, _this.getUrl = function () {
            var _this$props2 = _this.props,
                url = _this$props2.url,
                root = _this$props2.root,
                documentType = _this$props2.documentType,
                mediaType = _this$props2.mediaType,
                uniqueId = _this$props2.uniqueId;


            if (url) {
                return url;
            }

            url = [];

            if (root) {
                url.push(root);
            }

            if (documentType) {
                url.push(documentType);
            } else if (mediaType) {
                url.push("media");
                url.push(mediaType);
            }

            url.push(uniqueId);

            if (root) {
                url = url.join('/');
            } else {
                url = "/" + url.join('/');
            }

            return url;
        }, _this.getAction = function () {
            var moduleAction = _this.props.moduleAction;


            if (moduleAction === "link") {
                moduleAction = ["link"];
            }

            if (moduleAction === "edit") {
                moduleAction = ["edit", "refs", "delete", "select"];
            }

            if (moduleAction === "toggle") {
                moduleAction = ["toggle"];
            }

            return moduleAction;
        }, _this.formatSize = function (bytes, decimals) {
            if (bytes === 0) return '0 Bytes';

            var k = 1024,
                dm = decimals || 2,
                sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }, _this.getSize = function () {
            var _this$props3 = _this.props,
                mediaSize = _this$props3.mediaSize,
                mediaWidth = _this$props3.mediaWidth,
                mediaHeight = _this$props3.mediaHeight;


            if (!mediaSize) {
                return false;
            }

            if (mediaWidth && mediaHeight) {
                return mediaWidth + "×" + mediaHeight;
            }

            var size = void 0;

            if (!isNaN(mediaSize)) {
                size = _this.formatSize(mediaSize, 2);
            }

            return size;
        }, _this.getMetadata = function () {
            var metadata = _this.props.metadata;


            if (!metadata) {
                metadata = [];
            }

            var size = _this.getSize();

            metadata.push(size);

            return metadata;
        }, _this.getProps = function () {
            var label = _this.getLabel();
            var action = _this.getAction();
            var metadata = _this.getMetadata();
            var url = _this.getUrl();

            var editUrl = url + '/edit';
            var viewUrl = url + '/view';
            var refsUrl = url + '/refs';

            var linkUrl = void 0;

            if (action.includes("link")) {
                linkUrl = url;
            } else if (action.includes("edit")) {
                linkUrl = editUrl;
            }

            var _this$props4 = _this.props,
                moduleLayout = _this$props4.moduleLayout,
                moduleSize = _this$props4.moduleSize;


            if (moduleLayout == "list") {
                moduleSize = "small";
            }

            return _extends({}, _this.props, {
                moduleLayout: moduleLayout,
                moduleSize: moduleSize,
                label: label,
                action: action,
                url: url,
                linkUrl: linkUrl,
                editUrl: editUrl,
                viewUrl: viewUrl,
                refsUrl: refsUrl
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    FinderModule.prototype.render = function render() {
        var props = this.getProps();
        var selected = props.selected,
            status = props.status,
            url = props.url,
            linkUrl = props.linkUrl,
            title = props.title,
            description = props.description,
            label = props.label,
            metadata = props.metadata,
            action = props.action;


        if (linkUrl === url) {
            return React.createElement(
                Module,
                props,
                React.createElement(
                    ModuleLink,
                    { url: linkUrl },
                    React.createElement(
                        ModuleGrid,
                        props,
                        React.createElement(ModuleProgress, props),
                        React.createElement(ModuleMedia, props),
                        React.createElement(
                            ModuleContent,
                            null,
                            React.createElement(
                                ModuleHeader,
                                null,
                                React.createElement(ModuleTitle, { title: title }),
                                ' ',
                                ' ',
                                React.createElement(ModuleLabel, { label: label }),
                                ' ',
                                ' ',
                                React.createElement(ModuleMetadata, { metadata: metadata })
                            ),
                            React.createElement(
                                ModuleFooter,
                                null,
                                React.createElement(ModuleStatus, { status: status }),
                                ' ',
                                ' ',
                                React.createElement(ModuleByline, props)
                            )
                        )
                    )
                )
            );
        }

        return React.createElement(
            Module,
            props,
            React.createElement(
                ModuleLink,
                { url: linkUrl },
                React.createElement(
                    ModuleGrid,
                    props,
                    React.createElement(ModuleProgress, props),
                    React.createElement(ModuleMedia, props),
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(
                            ModuleHeader,
                            null,
                            React.createElement(ModuleTitle, { title: title }),
                            ' ',
                            ' ',
                            React.createElement(ModuleLabel, { label: label }),
                            ' ',
                            ' ',
                            React.createElement(ModuleMetadata, { metadata: metadata })
                        ),
                        React.createElement(
                            ModuleFooter,
                            null,
                            React.createElement(ModuleStatus, { status: status }),
                            ' ',
                            ' ',
                            React.createElement(ModuleByline, props)
                        )
                    )
                )
            ),
            React.createElement(ModuleAction, props)
        );
    };

    return FinderModule;
}(Component), _class.defaultProps = {
    moduleType: "finder",
    moduleLayout: "list",
    moduleSize: "auto",
    moduleAction: "link"
}, _temp2);
FinderModule.propTypes = process.env.NODE_ENV !== "production" ? {
    uniqueId: PropTypes.string,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    label: PropTypes.string,
    metadata: PropTypes.array,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string
} : {};


export default FinderModule;